// extracted by mini-css-extract-plugin
export default {"savedData":"test_savedData__+2Dkx"};